module.exports = __webpack_public_path__ + "img/icon.8e39fb16.png";